import { moment } from '~/vendorConfigs/moment';

const dateUnitsLookup: { [key: string]: 'days' | 'months' } = {
    d: 'days',
    m: 'months',
};
type DateUnitType = (typeof dateUnitsLookup)[keyof typeof dateUnitsLookup];

function dateFromAcceptableDateFormat(dateStr: string, endOfUnit?: boolean) {
    const date = moment(dateStr, ['MM/YYYY', 'M/YYYY', 'YYYY'], true);
    if (!date.isValid()) {
        return moment()
            [endOfUnit ? 'add' : 'subtract'](
                parseInt(dateStr),
                dateUnitsLookup[dateStr.slice(-1)] as DateUnitType
            )
            .toDate();
    }
    if (endOfUnit) {
        // Only applies if there are no units set
        // i.e. if we have been given just a year or month/year combo
        if (dateStr.length === 4) {
            // year only
            date.endOf('year');
        } else {
            // month + year - e.g. 9/2020 or 11/2020
            date.endOf('month');
        }
    }
    return date.toDate();
}

function datesFromExpression(expression: string) {
    // eslint-disable-next-line no-useless-escape
    const parts = expression.replace(/[\[\]]/gi, '').split(',');
    return {
        min: dateFromAcceptableDateFormat(parts[0]),
        max: dateFromAcceptableDateFormat(parts[2], true),
    };
}

export function getAcceptableDates(detail: MeasureDetailType) {
    if (!detail.acceptable_date_expression || detail.acceptable_date_expression === 'n/a') {
        const today = new Date();
        const yearsAgo = moment('01-01-1900').toDate();
        return {
            min: yearsAgo,
            max: today,
        };
    }
    const { min, max } = datesFromExpression(detail.acceptable_date_expression);
    const today = new Date();
    return {
        min,
        max: max > today ? today : max,
    };
}

export function getActiveStartDate(
    detail: MeasureDetailType,
    submissionAnswer?: SubmissionAnswerType
) {
    if (submissionAnswer?.metadata?.responses) {
        const existingResponse = submissionAnswer.metadata.responses.find(
            (x) =>
                (x?.quality_measure_detail?.id &&
                    Number(x.quality_measure_detail.id) === detail.id) ||
                (x?.foc_action_detail?.id && Number(x.foc_action_detail.id) === detail.id)
        );
        if (existingResponse?.date) {
            return moment(existingResponse.date.slice(0, -6)).toDate();
        }
    }

    if (!detail.acceptable_date_expression || detail.acceptable_date_expression === 'n/a')
        return null;

    const { max } = datesFromExpression(detail.acceptable_date_expression);
    const today = new Date();
    return max > today ? null : max;
}
